export const SEARCH_TYPE_QUERY_PARAM_NAME = 'searchType';
export const SEARCH_VALUE_QUERY_PARAM_NAME = 'query';
export const SMALL_SCREEN_SIZE = '(max-width: 719px)';
export const MEDIUM_SCREEN_SIZE = '(min-width: 720px) and (max-width: 1099px)';
export const BIG_SCREEN_SIZE = '(min-width: 1100px)';
export const EMAILS_URL_PATH = 'emails';
